import { Loader } from '@components';
import { User } from '@features/api/response/User';
import { useUserQuery } from '@features/api/userSlice';

export interface WithUserProps {
  user: User;
  refetchUser: () => void;
}

const WithUser = (Component: React.FC<WithUserProps>) => {
  const WithUserComponent = () => {
    const { data: user, isLoading, refetch } = useUserQuery();
    if (!user && isLoading) return <Loader isLoading={true} />;

    if (!user) return <></>;
    return <Component user={user} refetchUser={refetch} />;
  };

  return WithUserComponent;
};

export default WithUser;
